<!--
 * @Author: HANG ZHANG
 * @Date: 2020-06-04 20:08:43
 * @Description: 
 * @LastEditors: HANG ZHANG
 * @LastEditTime: 2020-06-04 20:08:43
 * @FilePath: /vision-h5/src/modules/icon/Icon.vue
-->
<template>
	<div
		class="root"
		:style="{
			transform: `rotate(${rotate}deg)`,
		}"
	>
		<i
			:class="['iconfont', name]"
			:style="{
				fontSize: comSize,
				color: color,
			}"
			v-if="type === 'fontClass'"
		></i>
		<svg class="icon" aria-hidden="true" :style="{ width: comSize, height: comSize, verticalAlign }" v-else>
			<use :xlink:href="`#${name}`"></use>
		</svg>
	</div>
</template>

<script>
	export default {
		name: 'icon',
		components: {},
		props: {
			size: {
				type: String,
				default: 1,
			},
			name: {
				type: String,
			},
			color: {
				type: String,
			},
			type: {
				type: String,
				default: 'fontClass',
			},
			verticalAlign: {
				type: String,
				default: '-0.15em',
			},
			rotate: {
				type: String,
				default: '0',
			},
		},
		data() {
			return {};
		},
		computed: {
			comSize() {
				return `${this.size * 0.005}rem`;
			},
		},
		watch: {},
		created() {},
		mounted() {},
		methods: {},
	};
</script>

<style scoped>
	.root {
		display: inline-block;
	}
	.icon {
		fill: currentColor;
		overflow: hidden;
	}
</style>



// WEBPACK FOOTER //
// src/modules/icon/Icon.vue